module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hwpuS"))).then(() => parcelRequire('d0iPb'));